import { render, staticRenderFns } from "./ShiftDeliveryFrequencyModal.vue?vue&type=template&id=9f79ff9e&scoped=true&"
import script from "./ShiftDeliveryFrequencyModal.vue?vue&type=script&lang=js&"
export * from "./ShiftDeliveryFrequencyModal.vue?vue&type=script&lang=js&"
import style0 from "./ShiftDeliveryFrequencyModal.vue?vue&type=style&index=0&id=9f79ff9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f79ff9e",
  null
  
)

export default component.exports